import React from "react";
import clsx from "clsx";

import { ReactComponent as IconPencil } from "../../../assets/svg/pencil.svg";
import { ReactComponent as IconDelete } from "../../../assets/svg/delete.svg";
import { ReactComponent as IconStudent } from "../../../assets/svg/student-comment.svg";
import { ReactComponent as IconTeacher } from "../../../assets/svg/teacher-comment.svg";
import { ReactComponent as IconEye } from "../../../assets/svg/eye.svg";
import { ReactComponent as IconEyeInvisible } from "../../../assets/svg/invisible.svg";
import { IAnswerComment, ITeacherR } from "../../../state";
import ModalDeleteConfirm from "../../../molecules/ModalDeleteConfirm";
import { generateFullName } from "../../../libs/Util";

import styles from "./FormReply.module.scss";

export type FormReplyProps = {
  comment: IAnswerComment;
  answerId: number;
  name_opened: boolean;
  calling?: boolean;
  currentTeacherID: number;
  handleDeleteComment: (answer_id: number, comment_id: number) => void;
  handleComment: (
    content: string,
    answerID: number,
    comment_id?: number,
  ) => void;
  handleToggleComment: (
    answer_id: number,
    comment_id: number,
    is_hidden: boolean,
  ) => void;
};

const FormReply: React.FC<FormReplyProps> = ({
  comment,
  answerId,
  name_opened,
  calling,
  currentTeacherID,
  handleComment,
  handleToggleComment,
  handleDeleteComment,
}) => {
  const [showForm, setShowForm] = React.useState(false);
  const [content, setContent] = React.useState(comment.content);
  const [openModal, setOpenModal] = React.useState<{
    state: boolean;
    type: "delete" | "hide";
    commentId: number;
    hiddenBy?: null | ITeacherR;
  }>({
    state: false,
    type: "delete",
    commentId: 0,
  });

  const updateComment = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleComment(content, answerId, comment.id);
    setShowForm(false);
  };

  return (
    <div className={styles.comment__content} key={comment.id}>
      {showForm ? (
        <form
          onSubmit={updateComment}
          className={clsx(styles.comment__content && styles.replyAnswer)}
        >
          <span>
            {comment.student_id || comment.student
              ? name_opened
                ? comment.student_id
                  ? comment.name
                  : generateFullName([
                      comment.student?.last_name,
                      comment.student?.first_name,
                    ])
                : ""
              : comment.teacher_id
              ? comment.name
              : generateFullName([
                  comment.teacher?.last_name,
                  comment.teacher?.first_name,
                ])}{" "}
            ( 編集中 )
          </span>
          <textarea
            rows={3}
            value={content}
            onChange={e => setContent(e.target.value)}
            placeholder="コメントを書く"
          />
          <div>
            <button
              type="submit"
              disabled={calling || !content || content === comment.content}
            >
              送信
            </button>
            <button
              onClick={() => {
                setShowForm(false);
              }}
            >
              キャンセル
            </button>
          </div>
        </form>
      ) : (
        <>
          <div>
            <span>
              {comment.student_id || comment.student ? (
                name_opened ? (
                  <>
                    <IconStudent />
                    <h6>
                      {comment.student_id
                        ? comment.name
                        : generateFullName([
                            comment.student?.last_name,
                            comment.student?.first_name,
                          ])}
                    </h6>
                  </>
                ) : (
                  ""
                )
              ) : (
                <>
                  <IconTeacher />
                  <h6>
                    {comment.teacher_id
                      ? comment.name
                      : generateFullName([
                          comment.teacher?.last_name,
                          comment.teacher?.first_name,
                        ])}
                  </h6>
                </>
              )}
            </span>
            <p>{comment.content}</p>
          </div>
          <div className={styles.comment__content__actionReply}>
            {(comment.teacher?.id === currentTeacherID ||
              comment.teacher_id === currentTeacherID ||
              comment.student) && (
              <>
                <IconPencil
                  className={clsx(calling && styles.disabled)}
                  onClick={() => {
                    setShowForm(true);
                  }}
                />
                {comment.hidden_by === null ? (
                  <IconEye
                    className={clsx(calling && styles.disabled)}
                    onClick={() =>
                      setOpenModal({
                        state: true,
                        type: "hide",
                        commentId: comment.id,
                        hiddenBy: comment.hidden_by,
                      })
                    }
                  />
                ) : (
                  <IconEyeInvisible
                    className={clsx(calling && styles.disabled)}
                    onClick={() =>
                      setOpenModal({
                        state: true,
                        type: "hide",
                        commentId: comment.id,
                        hiddenBy: comment.hidden_by,
                      })
                    }
                  />
                )}
                <IconDelete
                  className={clsx(calling && styles.disabled)}
                  onClick={() => {
                    setOpenModal({
                      state: true,
                      type: "delete",
                      commentId: comment.id,
                    });
                  }}
                />
              </>
            )}
          </div>
        </>
      )}
      {openModal.state && (
        <ModalDeleteConfirm
          title={
            openModal.type === "delete"
              ? "本当に削除しますか ?"
              : openModal.hiddenBy === null
              ? "このコメントを非表示にしてよろしいですか？"
              : "このコメントを再度表示してよろしいですか？"
          }
          onConfirm={() => {
            if (openModal.hiddenBy !== undefined) {
              handleToggleComment(
                answerId,
                openModal.commentId,
                !openModal.hiddenBy,
              );
            } else {
              handleDeleteComment(answerId, openModal.commentId);
            }
          }}
          onClose={() =>
            setOpenModal({
              state: false,
              type: "delete",
              commentId: 0,
            })
          }
        />
      )}
    </div>
  );
};

export default FormReply;
